import { MutationOptionsAlone } from 'apollo-angular/types';

export const uploadFileOptions: MutationOptionsAlone = {
  context: { useMultipart: true },
};

export const getGQLUploadFileOptions = (isUpload: boolean) => {
  return isUpload ? uploadFileOptions : undefined;
};
